// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const FILTER_DATASET_STEP_SHAPES = [
  {
    stepType: PipelineStepType.FILTER_DATASET,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      filter: {
        kind: 'taggedUnion',
        required: true,
        tagKey: 'operation',
        choices: [
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'AND'
              },
              filters: {
                kind: 'array',
                required: true,
                elementSpec: {
                  kind: 'taggedUnion',
                  required: true,
                  tagKey: 'operation',
                  choices: [
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'AND'
                        },
                        filters: {
                          kind: 'array',
                          required: true,
                          elementSpec: {
                            kind: 'taggedUnion',
                            required: true,
                            tagKey: 'operation',
                            choices: [
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'CONTAINS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'ENDS_WITH'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'GREATER_THAN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'GREATER_THAN_OR_EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'INCLUDES'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'IS_IN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'IS_NULL'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'LESS_THAN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'LESS_THAN_OR_EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'STARTS_WITH'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              }
                            ]
                          }
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'OR'
                        },
                        filters: {
                          kind: 'array',
                          required: true,
                          elementSpec: {
                            kind: 'taggedUnion',
                            required: true,
                            tagKey: 'operation',
                            choices: [
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'CONTAINS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'ENDS_WITH'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'GREATER_THAN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'GREATER_THAN_OR_EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'INCLUDES'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'IS_IN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'IS_NULL'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'LESS_THAN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'LESS_THAN_OR_EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'STARTS_WITH'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              }
                            ]
                          }
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'CONTAINS'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'ENDS_WITH'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'EQUALS'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'GREATER_THAN'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'GREATER_THAN_OR_EQUALS'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'INCLUDES'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'IS_IN'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'IS_NULL'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'LESS_THAN'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'LESS_THAN_OR_EQUALS'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'STARTS_WITH'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    }
                  ]
                }
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'OR'
              },
              filters: {
                kind: 'array',
                required: true,
                elementSpec: {
                  kind: 'taggedUnion',
                  required: true,
                  tagKey: 'operation',
                  choices: [
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'AND'
                        },
                        filters: {
                          kind: 'array',
                          required: true,
                          elementSpec: {
                            kind: 'taggedUnion',
                            required: true,
                            tagKey: 'operation',
                            choices: [
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'CONTAINS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'ENDS_WITH'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'GREATER_THAN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'GREATER_THAN_OR_EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'INCLUDES'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'IS_IN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'IS_NULL'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'LESS_THAN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'LESS_THAN_OR_EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'STARTS_WITH'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              }
                            ]
                          }
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'OR'
                        },
                        filters: {
                          kind: 'array',
                          required: true,
                          elementSpec: {
                            kind: 'taggedUnion',
                            required: true,
                            tagKey: 'operation',
                            choices: [
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'CONTAINS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'ENDS_WITH'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'GREATER_THAN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'GREATER_THAN_OR_EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'INCLUDES'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'IS_IN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'IS_NULL'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'LESS_THAN'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'LESS_THAN_OR_EQUALS'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  operation: {
                                    kind: 'string',
                                    required: true,
                                    value: 'STARTS_WITH'
                                  },
                                  columnSystemName: {
                                    kind: 'columnReference',
                                    required: true,
                                    inputDataName: 'Input dataset',
                                    validationOptions: null
                                  },
                                  not_: {
                                    kind: 'boolean',
                                    required: false
                                  },
                                  value: {
                                    kind: 'anything',
                                    required: true
                                  }
                                }
                              }
                            ]
                          }
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'CONTAINS'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'ENDS_WITH'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'EQUALS'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'GREATER_THAN'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'GREATER_THAN_OR_EQUALS'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'INCLUDES'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'IS_IN'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'IS_NULL'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'LESS_THAN'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'LESS_THAN_OR_EQUALS'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    },
                    {
                      kind: 'shape',
                      required: true,
                      fields: {
                        operation: {
                          kind: 'string',
                          required: true,
                          value: 'STARTS_WITH'
                        },
                        columnSystemName: {
                          kind: 'columnReference',
                          required: true,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        not_: {
                          kind: 'boolean',
                          required: false
                        },
                        value: {
                          kind: 'anything',
                          required: true
                        }
                      }
                    }
                  ]
                }
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'CONTAINS'
              },
              columnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              not_: {
                kind: 'boolean',
                required: false
              },
              value: {
                kind: 'anything',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'ENDS_WITH'
              },
              columnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              not_: {
                kind: 'boolean',
                required: false
              },
              value: {
                kind: 'anything',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'EQUALS'
              },
              columnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              not_: {
                kind: 'boolean',
                required: false
              },
              value: {
                kind: 'anything',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'GREATER_THAN'
              },
              columnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              not_: {
                kind: 'boolean',
                required: false
              },
              value: {
                kind: 'anything',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'GREATER_THAN_OR_EQUALS'
              },
              columnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              not_: {
                kind: 'boolean',
                required: false
              },
              value: {
                kind: 'anything',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'INCLUDES'
              },
              columnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              not_: {
                kind: 'boolean',
                required: false
              },
              value: {
                kind: 'anything',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'IS_IN'
              },
              columnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              not_: {
                kind: 'boolean',
                required: false
              },
              value: {
                kind: 'anything',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'IS_NULL'
              },
              columnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              not_: {
                kind: 'boolean',
                required: false
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'LESS_THAN'
              },
              columnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              not_: {
                kind: 'boolean',
                required: false
              },
              value: {
                kind: 'anything',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'LESS_THAN_OR_EQUALS'
              },
              columnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              not_: {
                kind: 'boolean',
                required: false
              },
              value: {
                kind: 'anything',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              operation: {
                kind: 'string',
                required: true,
                value: 'STARTS_WITH'
              },
              columnSystemName: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'Input dataset',
                validationOptions: null
              },
              not_: {
                kind: 'boolean',
                required: false
              },
              value: {
                kind: 'anything',
                required: true
              }
            }
          }
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
